module.exports = __webpack_public_path__ + "img/value2.b7aa56a3.png";